export default __webpack_public_path__ + "static/media/magnifier.1e1d38b9.svg";